import { Routes } from '@angular/router';
import { AppRoutes } from './core/constants/app-routes';
import { PublicLayout } from './core/layout/public-layout/public-layout';

export const routes: Routes = [
  {
    path: AppRoutes.HOME,
    component: PublicLayout,
    children: [
      {
        path: AppRoutes.HOME,
        loadComponent: () => import('./features/homepage/homepage').then((m) => m.Homepage),
      },
      {
        path: `${AppRoutes.EVENT_DETAILS}/:companyId/:eventId`,
        loadComponent: () =>
          import('./features/homepage/event-details-link').then((m) => m.EventDetailsLink),
      },
      {
        path: AppRoutes.JOIN_PLATFORM,
        loadComponent: () =>
          import('./features/join-platform/join-platform').then((m) => m.JoinPlatform),
      },
      {
        path: AppRoutes.PRIVACY_POLICY,
        loadComponent: () =>
          import('./features/legal/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
      },
      {
        path: AppRoutes.TERMS_AND_CONDITIONS,
        loadComponent: () =>
          import('./features/legal/terms-and-conditions/terms-and-conditions').then(
            (m) => m.TermsAndConditions,
          ),
      },
      {
        path: AppRoutes.COMPANIES.ROOT,
        children: [
          {
            path: '',
            loadComponent: () => import('./features/companies/list/list').then((m) => m.List),
          },
        ],
      },
    ],
  },
];
